/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// react-router components
import { useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// sweetalert2 components
import Swal from "sweetalert2";

import { putData } from "Utils/server";
import { getAuthorizationHeader, getUserData } from "Utils/helpers";

function DeleteAccount() {
  const [confirmed, setConfirmed] = useState(false);
  const userData = getUserData();

  let navigate = useNavigate();
  const routeChange = (path) => {
    navigate(path);
    return;
  };

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  const submitForm = async () => {
    if (!confirmed) return;
    await sleep(1000);

    let objSent = {};
    objSent.username = userData.username;
    objSent.firstName = userData.first_name;
    objSent.lastName = userData.last_name;
    objSent.username = userData.username;
    objSent.email = userData.email;
    objSent.role_id = userData.roles[0].id;
    objSent.status = false;

    const postProfileEndpoint = `/api/v1/users/${userData.id}/profile`;

    const setProfileResponse = await putData(postProfileEndpoint, objSent, {
      Authorization: getAuthorizationHeader(),
    });

    if (setProfileResponse) {
      Swal.fire(
        "Request Sent!",
        `Your Account is Succesfully de-activated. </br>Close this message to automatically signout.`,
        "success"
      ).then(async (result) => {
        routeChange(`/signout`);
      });
    } else {
      Swal.fire(
        "Error!",
        `Something goes Wrong while de-activating your Account. Please try again later.`,
        "error"
      );
    }
  };

  const setConfirmation = () => {
    setConfirmed(!confirmed);
  };

  return (
    <Card id="delete-account">
      <SoftBox p={3} lineHeight={1}>
        <SoftBox mb={1}>
          <SoftTypography variant="h5">Deactivate Account</SoftTypography>
        </SoftBox>
        <SoftTypography variant="button" color="text" fontWeight="regular">
          Once you deactivate your account, there is no going back. Please be certain.
        </SoftTypography>
      </SoftBox>
      <SoftBox
        pb={3}
        px={3}
        display="flex"
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        flexDirection={{ xs: "column", sm: "row" }}
      >
        <SoftBox display="flex" alignItems="center" mb={{ xs: 3, sm: 0 }}>
          <Switch onChange={setConfirmation} />
          <SoftBox ml={2} lineHeight={0}>
            <SoftTypography display="block" variant="button" fontWeight="medium">
              Confirm
            </SoftTypography>
            <SoftTypography variant="caption" color="text">
              I want to deactivate my account.
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <SoftBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>
          <SoftBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>
            <SoftButton
              variant="gradient"
              color="error"
              sx={{ height: "100%" }}
              disabled={!confirmed}
              onClick={submitForm}
            >
              deactivate
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </Card>
  );
}

export default DeleteAccount;
